/**
 * Contact Form Auto-Scroller
 * Inline script version - executes immediately on page load
 * Scrolls to the contact form section when URL contains #contact_form
 * URL is NOT modified - all query parameters are preserved
 * Handles both #contact_form and #contact_form?params formats
 */

(function() {
  'use strict';

  // Function to scroll to contact form
  function scrollToContactForm() {
    const contactFormElement = document.getElementById('contact-form__scroll');
    
    if (contactFormElement) {
      try {
        contactFormElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      } catch (e) {
        // Fallback for older browsers
        contactFormElement.scrollIntoView();
      }
    }
  }

  // Function to check and handle contact form URL
  function handleContactFormUrl() {
    const hash = window.location.hash;
    
    // Check if hash contains contact_form (handles both #contact_form and #contact_form?params)
    if (!hash || !hash.includes('contact_form')) {
      return;
    }

    // If document is already loaded, scroll immediately
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // Try multiple times to ensure element is rendered
      scrollToContactForm();
      setTimeout(scrollToContactForm, 300);
      setTimeout(scrollToContactForm, 800);
    }
  }

  // Run immediately on page load start
  handleContactFormUrl();

  // Listen for page load completion
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(handleContactFormUrl, 100);
    });
  }

  // Listen for window load (all resources loaded)
  window.addEventListener('load', function() {
    handleContactFormUrl();
  });

  // Handle manual hash changes
  window.addEventListener('hashchange', handleContactFormUrl);

  // Re-check periodically during page load in case element appears late
  var checkInterval = setInterval(function() {
    if (document.getElementById('contact-form__scroll')) {
      handleContactFormUrl();
      clearInterval(checkInterval);
    }
  }, 200);

  // Stop checking after 5 seconds
  setTimeout(function() {
    clearInterval(checkInterval);
  }, 5000);
})();

